export default __webpack_public_path__ + "roboto-v27-latin-regular.5e40c1.ttf";